import { makeAutoObservable } from "mobx";

class DashboardKpiStore {
  summary = { categories: [] };
  loading = false;
  hasLoadedOnce = false;
  requestSeq = 0;

  constructor() {
    makeAutoObservable(this);
  }

  nextRequestSeq = () => {
    this.requestSeq += 1;
    return this.requestSeq;
  };

  isStaleSeq = (seq) => seq !== this.requestSeq;

  setSummary = (summary) => {
    this.summary = summary ?? { categories: [] };
    this.hasLoadedOnce = true;
  };

  setLoading = (value) => {
    this.loading = Boolean(value);
  };

  reset = () => {
    this.summary = { categories: [] };
    this.loading = false;
    this.hasLoadedOnce = false;
  };
}

export const dashboardKpiStore = new DashboardKpiStore();
